import React, { Button, Typography, useMediaQuery, Box, useTheme, Avatar, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PersonIcon from '@mui/icons-material/Person';
import GitHubIcon from '@mui/icons-material/GitHub';
import { LogButtonEventToGA } from '../googleAnalytics/GoogleAnalytics';
import { changeAgentButtonClickedText } from '../googleAnalytics/GoogleAnalyticsConstants';
import { AgentMarketPlaceItemWithFilter } from '../../pages/userAgent/agentMarketPlace/AgentMarketPlace';

interface chatBannerProps {
  changeAgent: () => void;
  agentDetails: AgentMarketPlaceItemWithFilter;
}

const ChatBanner = ({ changeAgent, agentDetails }: chatBannerProps) => {
  LogButtonEventToGA(changeAgentButtonClickedText);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      <Box
        sx={{
          display: isMobile ? 'block' : 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          margin: isMobile ? '10px' : '0 20px',
          paddingTop: '64px',
        }}
      >
        <Button
          variant="outlined"
          onClick={changeAgent}
          sx={{
            marginBottom: isMobile ? '10px' : '0',
            width: 'auto',
          }}
        >
          Change Agent
        </Button>
        <Box
          sx={{
            transform: isMobile ? 'none' : 'translate(-60px, 10px)',
            position: 'relative',
            margin: isMobile ? '10px auto' : '0 auto',
            textAlign: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: isMobile ? '20px' : '24px',
              fontWeight: 'bold',
              color: '#0d47a1',
              marginTop: '0.5rem',
            }}
          >
            Try Out the Agent
          </Typography>
          <Typography
            sx={{
              fontSize: isMobile ? '12px' : '14px',
              color: '#555',
              marginBottom: '0.5rem',
              paddingBottom: '0.5rem',
            }}
          >
            Start with a trial prompt and discover how this agent can help you achieve your goals.
          </Typography>
        </Box>
      </Box>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          backgroundColor: '#eaf6ff',
          padding: 2,
          borderRadius: 1,
          width: '97%',
          borderLeft: '4px solid #0d47a1',
          margin: '0 auto',
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          <Avatar sx={{ bgcolor: '#0d47a1', width: 48, height: 48 }}>
            <PersonIcon sx={{ fontSize: 28 }} />
          </Avatar>
          <Box>
            <Typography variant="subtitle1" sx={{ fontSize: '1.2rem' }} fontWeight="bold" color="#0d47a1">
              {agentDetails.name}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {agentDetails.description}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: isMobile ? 1 : 2,
            color: '#0d47a1',
            cursor: 'pointer',
            flexShrink: 0,
          }}
        >
          <Tooltip title="GitHub" arrow placement="top">
            <Box sx={{ display: 'none' }}>
              <GitHubIcon fontSize="large" />
            </Box>
          </Tooltip>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title="More Details count" arrow placement="top">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <VisibilityIcon fontSize="large" />
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 'bold', marginBottom: '5px', cursor: 'pointer', fontSize: '1.5rem' }}
                >
                  {agentDetails.more_details_count ?? 0}
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ChatBanner;
